module.exports = __webpack_public_path__ + "static/img/th-crva-manual-03.c2668bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crva-manual-03.png
// module id = WwgI
// module chunks = 1